import { render, staticRenderFns } from "./bezelAndRails.vue?vue&type=template&id=5891e3f8&"
import script from "./bezelAndRails.vue?vue&type=script&lang=js&"
export * from "./bezelAndRails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports